<template>
    <!-- <router-link class="d-flex" v-if="header.routerActive" :to="{ name: routerName, query }">
      <div class="box-icon" v-if="header.iconName">
        <svgicon :name="header.iconName" :class="header.valueClass" />
      </div>
      <div>
        <h5>
          {{header.title}}
          <small>{{header.description}}</small>
        </h5>
        <h2 :class="header.valueClass">{{value}}</h2>
      </div>
    </router-link> -->
    <div class="d-flex min-height" @click="$hasPermission('view_trips') ? $emit('routeToTrack', header) : ''">
      <div class="box-icon" v-if="header.iconName">
        <svgicon :name="header.iconName" :class="header.valueClass" />
      </div>
      <div class="pointer">
        <h5>
          {{header.title}}
          <small>{{header.description}}</small>
        </h5>
        <h2 :class="header.valueClass">{{value}}</h2>
      </div>
    </div>
</template>

<script>
export default {
  props: ['header', 'value', 'routerName', 'routerQuery'],
  // computed: {
  //   query() {
  //     if (!Object.values(this.routerQuery).every(val => val == null)) {
  //       return this.routerQuery;
  //     }
  //     return null;
  //   },
  // },
};
</script>
